<template>
  <div class="page p-viewpoint">
    <div class="page__head">
      <page-header :back-location="localePath({ name: 'index' })" title="page_viewpoint.title" />
    </div>
    <div class="page__main page__main--fill">
      <wizard-selector />
    </div>
  </div>
</template>

<script>
  import WizardSelector from '@/components/wizard-selector/wizard-selector'
  import PageHeader from '@/components/page-header/page-header'

  export default {
    meta: {
      titleKey: 'meta.choose_viewpoint.title',
    },
    components: { PageHeader, WizardSelector },
  }
</script>
